var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.68L26 27.5L25.6 24.5L26 20.76V28L20 24.5L24 25.68ZM4.8 9.6H24V6.4H4.8V9.6ZM24 32C21.7867 32 19.9003 31.2197 18.3408 29.6592C16.7813 28.0987 16.0011 26.2123 16 24C15.9989 21.7877 16.7792 19.9013 18.3408 18.3408C19.9024 16.7803 21.7888 16 24 16C26.2112 16 28.0981 16.7803 29.6608 18.3408C31.2235 19.9013 32.0032 21.7877 32 24C31.9968 26.2123 31.2165 28.0992 29.6592 29.6608C28.1019 31.2224 26.2155 32.0021 24 32ZM0 30.4V3.2C0 2.32 0.3136 1.56693 0.9408 0.9408C1.568 0.314667 2.32107 0.00106667 3.2 0H25.6C26.48 0 27.2336 0.3136 27.8608 0.9408C28.488 1.568 28.8011 2.32107 28.8 3.2V13.88C28.2933 13.64 27.7733 13.44 27.24 13.28C26.7067 13.12 26.16 13 25.6 12.92V3.2H3.2V25.68H12.92C13.0533 26.5067 13.2603 27.2933 13.5408 28.04C13.8213 28.7867 14.1877 29.4933 14.64 30.16L14.4 30.4L12 28L9.6 30.4L7.2 28L4.8 30.4L2.4 28L0 30.4ZM4.8 22.4H12.92C13 21.84 13.12 21.2933 13.28 20.76C13.44 20.2267 13.64 19.7067 13.88 19.2H4.8V22.4ZM4.8 16H16.16C17.1733 15.0133 18.3536 14.2331 19.7008 13.6592C21.048 13.0853 22.4811 12.7989 24 12.8H4.8V16Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineOrders);
export default __webpack_public_path__ + "static/media/online-orders.c98214d398fb3ceec9616525a8eccb9d.svg";
export { ForwardRef as ReactComponent };